import {elementsWithScrolls} from "../../common/elementsWithScrolls";

interface ScrollPosition {
    element: HTMLElement;
    scrollTop: number;
}

const scrolls: Record<string, ScrollPosition[]> = {};

const saveScrolls = (routeName: string) => {
    const elements = elementsWithScrolls();
    scrolls[routeName] = [];
    elements.forEach((item: HTMLElement) => {
        scrolls[routeName].push({
            element: item,
            scrollTop: item.scrollTop
        });
    })
}

const restoreScrolls = (routeName: string) => {
    if (scrolls[routeName]) {
        setTimeout(() => {
            scrolls[routeName]?.forEach((item: ScrollPosition) => {
                item.element.scrollTop = item.scrollTop;
            });
        }, 400)
    }
}

const scrollTo = (selector: string) => {
    setTimeout(() => {
        const element = document.querySelector(selector);
        element && element.scrollIntoView();
    }, 400)
}

const resetScroll = (routeName: string) => {
    delete scrolls[routeName];
}

export { saveScrolls, restoreScrolls, resetScroll, scrollTo }
